import ReactDOM from 'react-dom/client';
import App from './App';
import PageView from './components/App/PageView';

/** @TOCHECK temporarely removed React strict mode because running the useeffect twice triggers initalizing the audio node twice */
ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <App>
    <PageView />
  </App>,
  // </React.StrictMode>
);
